import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import axios from 'axios';
import VueAxios from 'vue-axios';
import dayjs from "dayjs";
import cs from "dayjs/locale/cs"
dayjs.locale(cs);
createApp(App).use(router, axios, VueAxios).mount('#app');
